/* eslint-disable max-len */
import 'react';

const ArrowRightSvg = (
    props: React.SVGProps<SVGSVGElement>
): React.PropsWithoutRef<React.ReactSVGElement> => (
    <svg width="24px" height="24px" viewBox="0 0 24 24" fill="currentColor" {...props}>
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g fill="currentColor" fillRule="nonzero">
                <path d="M22.5514719,5.75147186 C23.020101,5.28284271 23.779899,5.28284271 24.2485281,5.75147186 C24.7171573,6.22010101 24.7171573,6.97989899 24.2485281,7.44852814 L13.4485281,18.2485281 C12.979899,18.7171573 12.220101,18.7171573 11.7514719,18.2485281 L0.951471863,7.44852814 C0.482842712,6.97989899 0.482842712,6.22010101 0.951471863,5.75147186 C1.42010101,5.28284271 2.17989899,5.28284271 2.64852814,5.75147186 L12.6,15.7029437 L22.5514719,5.75147186 Z" transform="translate(12.600000, 12.000000) scale(1, -1) rotate(-90.000000) translate(-12.600000, -12.000000) "></path>
            </g>
        </g>
    </svg>
);
export default ArrowRightSvg;
